export const measureoptions = [
  {
    id: '1',
    label: 'Documental',
    value: 'Documental'
  },
  {
    id: '2',
    label: 'Verificado',
    value: 'Verificado'
  }
];
